import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Lessons from './pages/html/Lessons';
import Csslessons from './pages/css/Csslessons';
import Jslessons from './pages/js/Jslessons';
import Home from './pages/Home';
import Htmlhome from './pages/html/Htmlhome';
import Csshome from './pages/css/Csshome';
import Jshome from './pages/js/Jshome';
import ScrollToTop from './ScrollToTop';
import Htmlm1l1 from './pages/html/lessons/Htmlm1l1';
import Htmlm1l2 from './pages/html/lessons/Htmlm1l2';
import Htmlm1l3 from './pages/html/lessons/Htmlm1l3';
import Htmlm1l4 from './pages/html/lessons/Htmlm1l4';


export default function App() {
  return (
  <Router>
    <ScrollToTop />
    <Switch>
    <Route path="/jslesson" component={Jslessons} />
    <Route path="/csslesson" component={Csslessons} />   
    <Route path="/lesson" component={Lessons} />
    <Route path="/js" component={Jshome} />
    <Route path="/css" component={Csshome} />
    <Route path="/htmlm1l1" component={Htmlm1l1} />
    <Route path="/htmlm1l2" component={Htmlm1l2} />
    <Route path="/htmlm1l3" component={Htmlm1l3} />
    <Route path="/htmlm1l4" component={Htmlm1l4} />
    <Route path="/html" component={Htmlhome} />
    <Route path="/" component={Home} />

    </Switch>
  </Router>
  )
}
